<template>
	<section class="ftco-section">
        <!-- <div class="lang-holder">
            <a href="javascript:void(0);" @click="updateLanguage('en')" style="margin:7px">
                <img alt="English" v-bind:src="require('../../assets/images/uk.png')" />
            </a>
            <a href="javascript:void(0);" @click="updateLanguage('da')" >
                <img alt="Denish" v-bind:src="require('../../assets/images/denmark.png')" />
            </a>
        </div> -->
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-md-6 text-center mb-5">
					<h2 class="heading-section"></h2> </div>
			</div>
			<div class="row justify-content-center">
				<div class="col-md-6 col-lg-5">
					<div class="login-wrap p-4 p-md-5">
						<div class="icon d-flex align-items-center justify-content-center"> <img :src="logo"> </div>
						<div class="form-group">
							<label class="label yb-label">{{ $t('message.EMAIL') }}</label>
							<input name="email" v-model="email" type="email" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('email') }" autocomplete="off"> 
                            <span v-show="errors.has('email')" class="invalid-feedback">{{ $t('message.VALID_EMAIL_ADDRESS') }}</span> </div>
						<div class="form-group">
							<label class="label yb-label">{{ $t('message.PASSWORD') }}</label>
							<input name="password" v-model="password" v-on:keyup.enter="login" type="password" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('password') }" autocomplete="off"> 
                            <span v-show="errors.has('password')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }} </span> </div>
						<!--<div class="form-group d-md-flex">
							<div class="w-50"></div>
							<div class="w-50 text-md-right"> <a href="#" style="color:#10707f">Forgot Password</a> </div>
						</div>-->
						<div class="form-group">
							<button type="submit" @click="login()" class="btn btn-info btn-block">{{ $t('message.LOGIN') }}</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
import Vue from 'vue'

export default {
    data(){
        return {
            email:'',
            password:'',
            image : require("../../assets/images/Circle Button.svg"),
            logo : require("../../assets/images/insurtech_logo.png")
        }
    },
    methods:{
         async login() {
            const valid = await this.$validator.validateAll()
            if (valid) {
                
                let form_data = {
                    email: this.email,
                    password: this.password,
                    locale:localStorage.getItem('lang')
                }

                let loader = this.$loading.show()

                try 
                {
                    const data_obj = await this.$store.dispatch('auth/login', form_data)
                    loader.hide()
                    this.$router.replace({
                       name: `truckers`
                    })
                } 
                catch (e) 
                {
                   this.$store.dispatch("notifications_alert/error", e.response.data.message)
                   loader.hide()
                }
            }
        },

        async updateLanguage(lang)
        {
            let loader = this.$loading.show()

            try
            {
                await Vue.prototype.$http.get('/api/auth/lang/'+lang)
                localStorage.setItem('lang', lang)
                this.$i18n.locale =  localStorage.getItem('lang')
                loader.hide()
            }
            catch(e)
            {
               loader.hide();
            }
        }
    },
    created()
    {
        if( localStorage.getItem('lang') == 'en') {
            this.updateLanguage('da')
        }

        if(localStorage.getItem('token'))
        {
            this.$router.replace({
                    name: `truckers`
                })
        }
        else
        {
            this.$router.replace({
                    name: `login`
                })
        }
    }
}
</script>
<style>
.login-wrap{
    box-shadow: 2px 3px 44px 14px #504e3329;
    margin-top: 40px;

}
.lang-holder {
    position: fixed;
    right: 25px;
    top: 10px;
}
</style>